import type {
  OrganizationAccess
} from "@camp-points/shared";
import { BrandShell } from "../components/BrandShell";

export function CampSwitcherPage({
  organizations,
  onSelect
}: {
  organizations: OrganizationAccess[];
  onSelect: (
    organizationId: string
  ) => void;
}) {
  return (
    <BrandShell eyebrow="Choose a camp">
      <div className="camp-list">
        {organizations.map(
          (organization) => (
            <button
              className="camp-option"
              key={
                organization.organizationId
              }
              onClick={() =>
                onSelect(
                  organization.organizationId
                )
              }
            >
              <img
                src={
                  organization.branding
                    .logoUrl ||
                  "/frontier-logo-transparent.png"
                }
                alt=""
              />

              <span>
                <strong>
                  {organization.name}
                </strong>
                <small>
                  {organization.role}
                </small>
              </span>
            </button>
          )
        )}
      </div>
    </BrandShell>
  );
}
